// import { createStore } from 'vuex'

// export default createStore({
//   state: {
//   },
//   mutations: {
//   },
//   actions: {
//   },
//   modules: {
//   },
// })

import { createStore } from 'vuex'

import * as modules from './modules'

export const state = () => ({})

export const pattern = {
  state,
  modules,
}

export const store = createStore(pattern)
